import { render, staticRenderFns } from "./course9.vue?vue&type=template&id=d0d0f4c2&scoped=true&"
import script from "./course9.vue?vue&type=script&setup=true&lang=js&"
export * from "./course9.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./course9.vue?vue&type=style&index=0&id=d0d0f4c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d0f4c2",
  null
  
)

export default component.exports